import { Toastr } from "@revvsales/components";
import { saveDocumentAsTemplateService } from "../../../../actions/DocumentTemplateActions/templateService";
import { GlobalUtils } from "../../../../utils";

const { handleApiErrMsg } = GlobalUtils;

const saveDocAsTemplate = (docID, templateName, setStateToInitial) => {
  const finalTemplateName = {
    template_name: templateName,
  };
  saveDocumentAsTemplateService(docID, finalTemplateName)
    .then(response => {
      const message = "Template successfully created";
      Toastr.showToastr({
        type: "success",
        message,
        timeout: 2000,
      });
      setStateToInitial();

      // http://localhost:3000/template/20
      const currentUrl = window.location.origin;
      window.open(`${currentUrl}/template/${response.Template.id}`);
    })
    .catch(error => {
      setStateToInitial();
      const message = handleApiErrMsg(error);
      Toastr.showToastr({
        type: "failure",
        message,
        timeout: 2000,
      });
    });
};

export default saveDocAsTemplate;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/DocToTemplate/methods.js